import {
  Grid,
  Card,
  CardContent,
  Typography,
  useTheme,
  Box,
  useMediaQuery,
  styled,
} from "@mui/material";
import { SchoolDashboardData } from "types/SchoolDashboardData";
import React from "react";
import SummaryDataBox from "./SummaryDataBox";
import BoxHeader from "./BoxHeader";
import FlexBetween from "./FlexBetween";
import { Pie, PieChart, Cell } from "recharts";
import { SchoolAggregateData } from "types/School";
import FlexBetweenBottom from "./FlexBetweenBottom";
import { iAdminDashboardData } from "types/AdminDashboardData";

const gridTemplateLargeScreens = `
  "a a b b c c d d d"
`;

const gridTemplateSmallScreens = `
  "a"
  "a"
  "b"
  "b"
  "c"
  "c"
  "d"
  "d"
`;

const BottomAlignedContainer = styled(Box)({
  display: "flex",
  alignItems: "flex-end",
});

const AdminDashboardSummary = ({
  numberOfSchools,
  numberOfStudents,
  testsTaken,
  overallPerformance,
}: iAdminDashboardData) => {
  const { palette } = useTheme();
  const isAboveMediumScreen = useMediaQuery("(min-width: 1200px");
  const theme = useTheme();

  if (
    !numberOfSchools ||
    !numberOfStudents ||
    !testsTaken ||
    !overallPerformance
  ) {
    return <Typography variant="h2">No data available</Typography>;
  }

  const overallPerformanceData = [
    { name: "Correct", value: overallPerformance },
    { name: "Incorrect", value: 100 - overallPerformance },
  ];

  const pieColors = [palette.primary[800], palette.primary[300]];

  return (
    <>
      <Box
        width="100%"
        height="100%"
        display="grid"
        gap="1.5rem"
        sx={
          isAboveMediumScreen
            ? {
                // gridTemplateColumns: "repeat(5, minmax(70px, 1fr))",
                gridTemplateColumns: "repeat(14, minmax(70px, 1fr))",
                gridTemplateRows: "repeat(1, minmax(120px, 1fr))",
                gridTemplateAreas: gridTemplateLargeScreens,
              }
            : {
                gridTemplateAreas: gridTemplateSmallScreens,
                gridAutoColumns: "1fr",
                gridAutoRows: "100px",
              }
        }
      >
        <SummaryDataBox gridArea="a">
          <BoxHeader title="Total Schools" sideText="" />
          <Box margin="1.5rem">
            <Typography variant="h2">{numberOfSchools}</Typography>
          </Box>
        </SummaryDataBox>
        <SummaryDataBox gridArea="b">
          <BoxHeader title="Total Students" sideText="" />
          <Box margin="1.5rem">
            <Typography variant="h2">{numberOfStudents}</Typography>
          </Box>
        </SummaryDataBox>
        <SummaryDataBox gridArea="c">
          <BoxHeader title="Tests Administered" sideText="" />
          <Box margin="1.5rem">
            <Typography variant="h2">{testsTaken}</Typography>
          </Box>
        </SummaryDataBox>
        <SummaryDataBox gridArea="d">
          <BoxHeader
            title="Overall Performance"
            sideText={
              (overallPerformance ? overallPerformance.toString() : "") + "%"
            }
          />
          <FlexBetween mt="0.25rem" gap="1.5rem" pr="1rem">
            <PieChart
              width={100}
              height={100}
              margin={{ top: 0, right: -10, bottom: 0, left: 10 }}
            >
              <Pie
                stroke="none"
                data={overallPerformanceData}
                innerRadius={18}
                outerRadius={38}
                paddingAngle={2}
                dataKey={"value"}
              >
                {overallPerformanceData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={pieColors[index]} />
                ))}
              </Pie>
            </PieChart>
          </FlexBetween>
        </SummaryDataBox>
      </Box>
    </>
  );
};

export default AdminDashboardSummary;
